<!--
 * @Description:
 * @Author: ma.cq
 * @Date: 2020-04-01 10:15:23
 * @LastEditors: ma.cq
 * @LastEditTime: 2020-04-14 10:27:12
 -->
<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    width="600px"
    @close="handleClose">
    <el-form :model="form" ref="form" :rules="rules" label-width="80px">
      <el-form-item label="标题" prop="title">
        <el-input v-model="form.title" placeholder="请输入标题"></el-input>
      </el-form-item>
      <el-form-item label="网址链接" prop="link">
        <el-input v-model="form.link" placeholder="请输入网址链接"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleSubmit">保 存</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { mapActions } from 'vuex'
import { checkUrl } from '../../../common/verify'

export default {
  name: 'addOrEditDialog',
  props: ['show', 'info'],
  data () {
    return {
      visible: false,
      id: '',
      form: {
        title: '',
        link: ''
      },
      rules: {
        title: [
          { required: true, message: '请输入标题' }
        ],
        link: [
          { required: true, message: '请输入网址链接' },
          { pattern: checkUrl, message: '请输入带http或https的完整链接' }
        ]
      }
    }
  },
  computed: {
    title () {
      return this.isEdit ? '编辑' : '新增'
    },
    isEdit () {
      return !this.$lodash.isEmpty(this.info)
    }
  },
  methods: {
    ...mapActions(['getUploadCenterJbIndustryList', 'addOrEditUploadCenterJbIndustry']),
    handleClose () {
      this.$emit('update:show', false)
    },
    handleSubmit () {
      this.$refs['form'].validate(valid => {
        if (valid) {
          let params = {
            url: this.form.link,
            title: this.form.title
          }
          if (this.isEdit) {
            params = {
              ...params,
              id: this.id
            }
          }
          this.addOrEditUploadCenterJbIndustry(params).then(() => {
            this.$message.success('保存成功')
            this.handleClose()
            this.getUploadCenterJbIndustryList()
          })
        } else {
          return false
        }
      })
    },
    formatForm (form) {
      const {
        url,
        title,
        id
      } = form
      this.id = id
      return {
        title,
        link: url
      }
    }
  },
  watch: {
    show (newVal) {
      this.visible = newVal
      if (newVal) {
        this.form = this.isEdit ? this.formatForm(this.info) : {
          title: '',
          link: ''
        }
        this.$nextTick(() => {
          this.$refs['form'].clearValidate()
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
/deep/ .el-input, /deep/ .el-select {
  width: 200px;
}
</style>
